import { Injectable } from "@angular/core";
import { Actions, concatLatestFrom, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { ProductType } from "@obg/core.config";
import { RouteAction } from "@obg/ngx.router";
import { filter, map } from "rxjs/operators";

import { CoreState } from "../state";

import { AppContextAction } from "./app-context.action";
import { AppContextSelector } from "./app-context.selector";

@Injectable()
export class AppContextEffect {
	routeChange$ = createEffect(() =>
		this.actions$.pipe(
			ofType(RouteAction.resolveEnd),
			map(({ payload: { current } }) => current?.data.product || ProductType.Common),
			concatLatestFrom(() => this.store.select(AppContextSelector.getProduct)),
			filter(([product, currentProduct]) => product !== currentProduct),
			map(([product]) => this.action.setProduct(product))
		)
	);

	constructor(
		private actions$: Actions,
		private action: AppContextAction,
		private store: Store<CoreState>
	) {}
}
